import React, { Component } from 'react';
import { Accordion, Icon } from 'semantic-ui-react';
import { PtSelect, PtDateInput } from '../../../../grit-utilities';
import DropdownLib from '../../../../DropdownLib';
import MaintenanceTemplate from './maintenance-template';

export default class Striping extends Component {
    constructor(props) {
        super(props);
        const { csModel } = this.props;
        this.state = csModel.maintenance;
    }

    componentWillMount() {
        this.setState({
            selectedIndex: 0
        });
    }

    render() {
        return (
            <MaintenanceTemplate dataModel={this.state.striping}
                selectedIndex={this.state.selectedIndex}
                name="Striping"

                updateSelectedIndex={(index) => this.setState({ selectedIndex: index })}
                updateDataModel={(tempArray) => this.setState({ striping: tempArray })}

                templadeData={{
                    centerlineType: 0,
                    centerlineWidth: 0,
                    centerlineDate: null,
                    centerlineContrast: 0,
                    centerlineSchedule: 0,
                    centerlineRumble: 0,
                    centerlineRumbleType: 0,

                    edgelineType: 0,
                    edgelineWidth: 0,
                    edgelineDate: null,
                    edgelineContrast: 0,
                    edgelineSchedule: 0,
                    edgelineRumble: 0,
                    edgelineRumbleType: 0
                }}

                triggerNeedSave={this.props.triggerNeedSave}
                deleteRecord={(tempArray) => this.setState({ selectedIndex: 0, striping: tempArray })}
                addRecord={(index, tempArray) => this.setState({ selectedIndex: index, striping: tempArray })}
                disabled={this.props.disabled}

                renderMaintenance={this.renderMaintenance}
            />
        );
    }
    // renderMaintenance needs all of these or you will run into issues of crashing.
    renderMaintenance = (onChangeIndex, onChangeDropdown, onChangeDropdownEstimated, onInputChange, onChangeDate ) => {
        const { centerlineTypeOptions,
                centerlineWidthOptions,
                centerlineContrastOptions,
                centerlineScheduleOptions,
                centerlineRumbleOptions,
                centerlineRumbleTypeOptions,
                edgelineRumbleTypeOptions} = DropdownLib.getDropdowns().CSM_Striping;

        //const { completedByOptions } = DropdownLib.getDropdowns().CS_SurfaceTreatment;

        const selected = this.state.selectedIndex;

        return (
            <div>
                {/* striping */}

                <Accordion fluid>
                    <Accordion.Title className="accordion-title">
                        <Icon name='dropdown' />
                        Centerline
                        </Accordion.Title>
                    <Accordion.Content>

                        <PtSelect label="Type" options={centerlineTypeOptions}
                            name="centerlineType"
                            defaultVal={this.state.striping[selected].centerlineType}
                            onChange={onChangeDropdown}
                            disabled={this.props.disabled} />

                        <PtSelect label="Width (inches)" options={centerlineWidthOptions}
                            name="centerlineWidth"
                            defaultVal={this.state.striping[selected].centerlineWidth}
                            onChange={onChangeDropdown}
                            disabled={this.props.disabled} />

                        <PtDateInput label="Date"
                            value={this.state.striping[selected].centerlineDate}
                            disabled={this.props.disabled}
                            onChange={(date) => { onChangeDate(date, "centerlineDate"); }}
                            name="centerlineDate" />

                        <PtSelect label="Contrast" options={centerlineContrastOptions}
                            name="centerlineContrast"
                            defaultVal={this.state.striping[selected].centerlineContrast}
                            onChange={onChangeDropdown}
                            disabled={this.props.disabled} />

                        <PtSelect label="Striping Schedule - Every ____ Year(s)" options={centerlineScheduleOptions}
                            name="centerlineSchedule"
                            defaultVal={this.state.striping[selected].centerlineSchedule}
                            onChange={onChangeDropdown}
                            disabled={this.props.disabled} />

                        <PtSelect label="Rumble Type" options={centerlineRumbleTypeOptions}
                            name="centerlineRumbleType"
                            defaultVal={this.state.striping[selected].centerlineRumbleType}
                            onChange={onChangeDropdown}
                            disabled={this.props.disabled} />

                        <PtSelect label="Rumble Maintenance" options={centerlineRumbleOptions}
                            name="centerlineRumble"
                            defaultVal={this.state.striping[selected].centerlineRumble}
                            onChange={onChangeDropdown}
                            disabled={this.props.disabled} />

                    </Accordion.Content>
                </Accordion>

                <Accordion fluid>
                    <Accordion.Title className="accordion-title">
                        <Icon name='dropdown' />
                        Edgeline
                        </Accordion.Title>
                    <Accordion.Content>

                        <PtSelect label="Type" options={centerlineTypeOptions}
                            name="edgelineType"
                            defaultVal={this.state.striping[selected].edgelineType}
                            onChange={onChangeDropdown}
                            disabled={this.props.disabled} />

                        <PtSelect label="Width (inches)" options={centerlineWidthOptions}
                            name="edgelineWidth"
                            defaultVal={this.state.striping[selected].edgelineWidth}
                            onChange={onChangeDropdown}
                            disabled={this.props.disabled} />

                        <PtDateInput label="Date"
                            value={this.state.striping[selected].edgelineDate}
                            disabled={this.props.disabled}
                            onChange={(date) => { onChangeDate(date, "edgelineDate"); }}
                            name="edgelineDate" />

                        <PtSelect label="Contrast" options={centerlineContrastOptions}
                            name="edgelineContrast"
                            defaultVal={this.state.striping[selected].edgelineContrast}
                            onChange={onChangeDropdown}
                            disabled={this.props.disabled} />

                        <PtSelect label="Striping Schedule - Every ____ Year(s)" options={centerlineScheduleOptions}
                            name="edgelineSchedule"
                            defaultVal={this.state.striping[selected].edgelineSchedule}
                            onChange={onChangeDropdown}
                            disabled={this.props.disabled} />

                        <PtSelect label="Rumble Type" options={edgelineRumbleTypeOptions}
                            name="edgelineRumbleType"
                            defaultVal={this.state.striping[selected].edgelineRumbleType}
                            onChange={onChangeDropdown}
                            disabled={this.props.disabled} />

                        <PtSelect label="Rumble Maintenance" options={centerlineRumbleOptions}
                            name="edgelineRumble"
                            defaultVal={this.state.striping[selected].edgelineRumble}
                            onChange={onChangeDropdown}
                            disabled={this.props.disabled} />

                    </Accordion.Content>
                </Accordion>
               
            </div >);
    }
}


// WEBPACK FOOTER //
// ./src/layers/tabs/cons-segment/maintenance/striping.js